var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/glass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8335 36.4583H29.1668",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.1665 36.4583V15.625C4.1665 7.29165 6.24984 5.20831 14.5832 5.20831",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.8332 36.4583V15.625C45.8332 7.29165 43.7498 5.20831 35.4165 5.20831",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8332 33.1458V40C20.8332 44.1667 19.1665 45.8333 14.9998 45.8333H9.99984C5.83317 45.8333 4.1665 44.1667 4.1665 40V33.1458C4.1665 28.9792 5.83317 27.3125 9.99984 27.3125H14.9998C19.1665 27.3125 20.8332 28.9792 20.8332 33.1458Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.8332 33.1458V40C45.8332 44.1667 44.1665 45.8333 39.9998 45.8333H34.9998C30.8332 45.8333 29.1665 44.1667 29.1665 40V33.1458C29.1665 28.9792 30.8332 27.3125 34.9998 27.3125H39.9998C44.1665 27.3125 45.8332 28.9792 45.8332 33.1458Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassIcon);
export default __webpack_public_path__ + "static/media/glass-icon.9e33f07e3c34b53304bca83ef8546d7e.svg";
export { ForwardRef as ReactComponent };